/* eslint-disable react/jsx-no-useless-fragment */
import { FC } from 'react';
import Moment from 'react-moment';
import { i18n } from '@lingui/core';
import moment from 'moment';
import { WorkflowStepDTO } from '../../../Types/LogT';

const WorklowStepScheduleInfo: FC<{ workflowStep: WorkflowStepDTO }> = ({ workflowStep }) => {
  const { procedureType, executionReport, executionConfig } = workflowStep;
  const { executionStatus, executedAt } = executionReport ?? {};
  const { thresholdDate, manualApprovalRequired } = executionConfig;

  if (executionStatus === 'FULFILLED' && executedAt) {
    return <>{`Gewartet bis ${moment(executedAt).calendar()}`}</>;
  }

  if (executionStatus === 'SKIPPED') {
    return <>Übersprungen </>;
  }

  if (executionStatus === 'COMPLETED') {
    return (
      <>
        Ausgeführt <Moment fromNow date={executedAt} />
      </>
    );
  }
  if (manualApprovalRequired) {
    return <>Manuelle Genehmigung erforderlich</>;
  }
  if (thresholdDate) {
    if (procedureType !== 'WAIT_UNTIL') {
      return (
        <>
          Geplant <Moment calendar date={thresholdDate} />
        </>
      );
    }
    return (
      <>
        Warten bis <Moment fromNow date={thresholdDate} />
      </>
    );
  }
  const { relativeAmount, relativeUnit, executionStrategy } = executionConfig;
  const relativeStr = `${relativeAmount} ${i18n._(`chronoUnit.${relativeUnit}`)}`;

  if (procedureType === 'WAIT_UNTIL') {
    return <>Warten {relativeStr}</>;
  }

  if (executionStrategy === 'AFTER_PREVIOUS_STEP') {
    return <>{relativeAmount > 0 ? `Nach ${relativeStr} ausführen` : 'Sofort ausführen'}</>;
  }

  const strategyTranslation = `${i18n._(`execution.${executionStrategy}`)}`;

  return <>{relativeAmount > 0 ? `${relativeStr} ${strategyTranslation}` : strategyTranslation}</>;
};

export default WorklowStepScheduleInfo;
